import { Box, Button, colors, Typography } from '@material-ui/core';
import { ProfileImageCropper } from 'components/RegistrationForm/AdultForm/ProfileImageAdult/ProfileImageCropper';
import React, { useRef, useState } from 'react';
import { IOutput } from 'shared/interfaces/IProfile';
import { IoMdAdd } from 'react-icons/io';
import { COLORS } from 'shared/constants/COLORS';
import { AddCircleOutline } from '@material-ui/icons';

type Props = {
  onFileSelected: (
    fname: string,
    type: string,
    size: string,
    file?: Blob,
    imageAttr?: { width: number; height: number },
  ) => void;
};

const GroupPhoto: React.FC<Props> = ({ onFileSelected }) => {
  const [file, setFile] = useState<File | null>(null);
  const inputFile = useRef<HTMLInputElement>(null);
  const [fileDataURL, setFileDataURL] = useState(null);
  const [cropper, setCropper] = useState<any>(null);

  const getCropData = (data: IOutput) => {
    onFileSelected(file?.name || data.file_name, data.file_type, data.file_size, data.attachment, {
      width: parseInt(data.file_height),
      height: parseInt(data.file_height),
    });
  };

  const changeHandler = (e: any) => {
    const file = e.target.files[0];

    setFile(file);

    let fileReader: any,
      isCancel = false;
    if (file) {
      fileReader = new FileReader();
      const image = new Image();
      fileReader.onload = (e: any) => {
        const { result } = e.target;
        image.src = fileReader.result as string;
        setFileDataURL(result);
      };
      fileReader.readAsDataURL(file);
    }
    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    };
  };

  const handleClick = () => {
    if (inputFile) {
      inputFile.current?.click();
    }
  };

  return (
    <Box
      onClick={() => !file && handleClick()}
      style={{ marginTop: 10, display: 'flex', flexDirection: 'column', position: 'relative' }}
    >
      <input
        hidden
        ref={inputFile}
        id="contained-input-file"
        type="file"
        accept="image/*"
        onClick={(e) => {
          e.stopPropagation();
        }}
        onChange={(e) => {
          changeHandler(e);
        }}
      />
      {!file && (
        <Button style={{ position: 'absolute', width: '100%', height: '100%', borderRadius: 8 }}>
          <Box
            style={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',

              flexDirection: 'column',
            }}
          >
            <AddCircleOutline style={{ width: 40, height: 40, marginBottom: 10 }} />
            <Typography>Upload Family / Group Image</Typography>
          </Box>
        </Button>
      )}
      <ProfileImageCropper
        addFamily
        src={fileDataURL ? fileDataURL : ''}
        cropper={cropper}
        setCropper={setCropper}
        handleCrop={getCropData}
      />

      {file && (
        <Button
          onClick={handleClick}
          style={{
            alignSelf: 'center',
            width: 200,
            height: 44,
            maxWidth: 283,
            border: '1px solid #3e8bff',
            background: '#0c0f14',
            borderRadius: 8,
            marginTop: -15,
          }}
        >
          Change
        </Button>
      )}
    </Box>
  );
};

export default GroupPhoto;
